import React from 'react';
import {Field, reduxForm} from 'redux-form';
import ValidatedInputField from '../../common/form/ValidatedInputField';
import SubmitButton from "../../common/SubmitButton";
import { injectIntl } from 'react-intl';
import {messages} from  '../../common/Translations';
import afterSubmitFail from '../../common/form/focusAfterSubmitFail';
import PortalSelect from "../../portal-contact/PortalSelect";
import ValidatedTextAreaField from "../../common/form/ValidatedTextAreaField";
import {articleCategoryFormValidator} from "./articleCategoryFormValidator";

class ArticleCategoryForm extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <form onSubmit={this.props.handleSubmit} noValidate={true}>
                <Field
                    name="portalId"
                    type="select"
                    component={PortalSelect}
                    label={this.props.intl.formatMessage(messages.portal)}
                    options={this.props.portals}
                    placeholder={this.props.intl.formatMessage(messages.select)}
                />
                <Field
                    type="text"
                    name="name"
                    component={ValidatedInputField}
                    placeholder={this.props.intl.formatMessage(messages.headingPlaceholder)}
                    className="form-control"
                    label={this.props.intl.formatMessage(messages.title)}
                />
                <Field
                    type="text"
                    name="description"
                    component={ValidatedTextAreaField}
                    placeholder={this.props.intl.formatMessage(messages.descriptionPlaceholder)}
                    className="form-control"
                    label={this.props.intl.formatMessage(messages.description)}
                />
                <hr/>
                <div className="form-group row">
                    <div className="col-sm-12">
                        <div className="offset-sm-2">
                            <SubmitButton isUpdate={this.props.isUpdate}/>
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}

ArticleCategoryForm = reduxForm({
    form: 'article-category',
    validate: articleCategoryFormValidator,
    onSubmitFail: afterSubmitFail
})(ArticleCategoryForm);

export default injectIntl(ArticleCategoryForm);


// WEBPACK FOOTER //
// ./web/src/components/articles/category/ArticleCategoryForm.jsx